import {
    UpdateIconButton,
    pn,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@compass/core";

import { ListBeProperty } from "components";
import {
    Permission,
    PermissionAction,
    SortObject,
    DiplomaTypeListDto,
    DiplomaTypeListResource
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { diplomaTypePageRoute } from "../DiplomaTypePage/DiplomaTypePage";

export const DiplomaTypeTable = (props: {
    rootPermission: Permission;
    tableContainerRef: React.RefObject<HTMLDivElement>;
    diplomaTypes: DiplomaTypeListDto[];
    setDiplomaTypes: (diplomaTypes: DiplomaTypeListDto[]) => void;
    resource: DiplomaTypeListResource;
    searchFocused: boolean;
    sortObjects: SortObject[] | undefined;
    sort: (sortObjects: SortObject[]) => void;
    loadList: () => void;
}) => {
    const navigate = useNavigate();
    const properties = props.resource.properties || [];

    return (
        <TableContainer ref={props.tableContainerRef}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "7%"}}>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<DiplomaTypeListDto>("id"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<DiplomaTypeListDto>("name"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {props.diplomaTypes.map((diplomaTypeItem) => (
                        <TableRow
                            key={diplomaTypeItem.id}
                            onClick={() =>
                                navigate(
                                    diplomaTypePageRoute.getPath({
                                        id: diplomaTypeItem.id,
                                        crudMode: "view",
                                        screenType: "dialog"
                                    })
                                )
                            }
                        >
                            <TableCell>{diplomaTypeItem.id}</TableCell>
                            <TableCell>
                                <Stack direction="row" spacing="sm" alignItems="center" justifyContent="space-between">
                                    <Typography variant="inherit">{diplomaTypeItem.name}</Typography>
                                </Stack>
                            </TableCell>
                            <TableCell type="action">
                                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                                    <UpdateIconButton color="primary"
                                        onClick={() =>
                                            navigate(
                                                diplomaTypePageRoute.getPath({
                                                    id: diplomaTypeItem.id,
                                                    crudMode: "edit",
                                                    screenType: "dialog"
                                                })
                                            )
                                        }
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
